import { z } from "zod";

export const MESSENGERS = ["WhatsApp", "Telegram", "LINE", "WeChat"] as const;

export type Messenger = (typeof MESSENGERS)[number];

export type ContactFormMessages = {
  nameRequired: string;
  phoneRequired: string;
  phoneInvalid: string;
};

export function createContactFormSchema(messages: ContactFormMessages) {
  return z.object({
    name: z.string().trim().min(2, messages.nameRequired),
    phone: z
      .string()
      .trim()
      .min(6, messages.phoneRequired)
      .regex(/^[0-9+()\s-]+$/, messages.phoneInvalid),
    messenger: z.enum(MESSENGERS),
  });
}

export type ContactFormValues = z.infer<
  ReturnType<typeof createContactFormSchema>
>;

/**
 * Серверная схема заявки. Клиентская валидация ничего не гарантирует: в /api/lead
 * и в MCP-инструмент запрос может прийти напрямую от бота или агента. Дополнительно
 * ограничиваем длины, чтобы в чат продаж не приехала строка на сотни килобайт.
 */
export const leadSchema = z.object({
  name: z.string().trim().min(2).max(100),
  phone: z
    .string()
    .trim()
    .min(6)
    .max(32)
    .regex(/^[0-9+()\s-]+$/, "phone contains unexpected characters"),
  messenger: z.enum(MESSENGERS),
  /** Локаль страницы, с которой пришла заявка - нужна отделу продаж, не пользователю. */
  locale: z.string().trim().max(8).optional(),
  /** Откуда пришла заявка: форма сайта или инструмент агента. */
  source: z.enum(["form", "agent"]).optional(),
  /**
   * Honeypot: люди это поле не видят и не заполняют. Схема принимает любую строку -
   * непустое значение обрабатывается отдельно (тихий успех), иначе бот по коду
   * ответа сразу понял бы, что попался.
   */
  company: z.string().max(200).optional(),
});

export type LeadInput = z.infer<typeof leadSchema>;
